import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { passiveVoiceData, getDataForDifficulty } from '../courses/data/grammar/passiveVoice';

export default function PassiveVoiceTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : passiveVoiceData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
